

import { IParentTagGroup } from '@/src/interfaces/tag-manager';
import { ITag } from "@clickster/constant-definitions/dist-esm/entities/tag/types";
import { StateCreator } from 'zustand';
import { LocalStorage } from '@/src/utils/general/local-storage';

export interface TagsStore {
  tags: ITag[];
  tagsGroups: { [key: string]: IParentTagGroup }
  tagsById: { [key: string]: ITag }
  hydrated: boolean;
  hydrate: () => void;
}

export const createTagsStore: StateCreator<TagsStore> = (set) => {
  return {
    tags: [],
    tagsGroups: {},
    tagsById: {},
    hydrated: false,
    hydrate: () => {
      const storedTags = LocalStorage.get('tag-manager');
      set({
        tags: storedTags?.tags || [],
        tagsGroups: storedTags?.tagsGroups || {},
        tagsById: storedTags?.tagsById || {},
        hydrated: true
      });
    }
  }
};
